import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogClose,
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { RestClientService } from 'src/app/core/service/rest-client.service';
import { AuthService } from 'src/app/core/service/auth.service';
import { Subscription } from 'rxjs';
import { UtilitiesService } from 'src/app/core/service/utilities.service';

export interface PrescriptionActeChatDialogData {
  item: any;
}

@Component({
  selector: 'app-prescription-acte-chat-dialog',
  templateUrl: './prescription-acte-chat-dialog.component.html',
  styleUrls: ['./prescription-acte-chat-dialog.component.scss'],
})
export class PrescriptionActeChatDialogComponent {
  messages: any[] = [];
  itemToSave: any = {};
  busyGet: Subscription;
  imageName: string;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  user: any;
  dialogTitle: string;
  private intervalId: any;

  constructor(
    public dialogRef: MatDialogRef<PrescriptionActeChatDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PrescriptionActeChatDialogData,
    private restClient: RestClientService,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {
    this.user = this.authService.getCurrentUser();
    this.dialogTitle = 'Discussion – ' + (data.item?.acte_libelle || data.item?.libelle || '');

    this.getItemsMessages();
    this.intervalId = setInterval(() => {
      this.getItemsMessages();
    }, 5000);
  }

  getItemsMessages() {
    const request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      order_by: 'created_at',
      data: { prescription_acte_id: this.data.item.id },
    };

    this.busyGet = this.restClient
      .post('prescriptionActeChat/getByCriteria', request)
      .subscribe(
        (res) => {
          if (res && res['items']) {
            this.messages = res['items'];
            this.messages.forEach((msg: any) => {
              msg.isSent = msg.created_by_id === this.user.id;
              msg.image_url = msg.image || msg.ged_file_url || null;
            });
          } else {
            this.messages = [];
          }
        },
        () => { this.messages = []; }
      );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const tabExt = file.name.split('.');
      const extension = tabExt[tabExt.length - 1];
      this.imageName = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        const fileBase64 = data.split(',')[1];
        this.currentItemImage = { fileBase64, fileName, extension, typeDocument: 'custom type' };
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  saveItem() {
    this.itemToSave.prescription_acte_id = this.data.item.id;
    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      this.itemToSave.file_data = this.currentItemImage;
    }

    const request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [this.itemToSave],
    };

    this.busyGet = this.restClient.post('prescriptionActeChat/create', request).subscribe(
      (res: any) => {
        if (res && !res.hasError) {
          this.utilities.showNotification('snackbar-success',
            this.utilities.formatMsgServeur(res.status.message), 'bottom', 'center');
          this.itemToSave = {};
          this.imageName = null;
          this.currentItemImage = null;
          this.getItemsMessages();
        } else {
          this.utilities.showNotification('snackbar-danger',
            this.utilities.formatMsgServeur(res.status.message), 'bottom', 'center');
        }
      },
      (error: any) => {
        this.utilities.showNotification('snackbar-danger', error, 'bottom', 'center');
      }
    );
  }

  onSendMessage() {}

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  clearInterv() {
    clearInterval(this.intervalId);
  }
}
